import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=23928c80&scoped=true&"
import script from "./PositionForm.vue?vue&type=script&lang=js&"
export * from "./PositionForm.vue?vue&type=script&lang=js&"
import style0 from "./PositionForm.vue?vue&type=style&index=0&id=23928c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23928c80",
  null
  
)

component.options.__file = "PositionForm.vue"
export default component.exports